// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__zALXy","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__11faF","gfeWrapper":"CalendarEvent_gfeWrapper__5yujX"};